import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { CORE_FUNCTIONS, IServerResponse } from '@app/core';
import { IBusquedaAutoComplete } from '../interfaces/busqueda-autocomplete.interface';
import { environment } from 'src/environments/environment';
import { IDataGridPageRequest } from 'shared';
import { IResumenUniversidadPrograma } from '../interfaces/resumen-universidad-programa.interface';

@Injectable()
export class HomeService {

  // private urlPortalSiu = `${environment.urls.SUNEDU_PORTAL_API_V1}/Home`
  private urlPortalSiu = `${environment.baseUrlAPI}/Home`
  private urlPortalTuniDWH = `${environment.baseUrlAPIDWH}`;
  private urlEntidad: string = `${environment.baseUrlAPIDWH}/Entidad`;
  private urlLocalPrograma: string = `${environment.baseUrlAPIDWH}/localprograma`;
  constructor(private http: HttpClient) { }

  buscarUniversidades = (pageRequest: IDataGridPageRequest, filters: any) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlEntidad}/listar`, {
      ...pageRequest,
      orderBy: "asc",
      ...filters,
      // filters: {
      //   codigoDistrito: null,
      //   codigoProvincia: null,
      //   codigoRegion: null,
      //   maxDistancia: 50,
      //   minDistancia: 1,
      //   tiposGestion: [],
      //   useFiltroDistancia: false,
      //   userGeoCoordinate: null
      // }
    });
  }


  buscarProgramas = (pageRequest: IDataGridPageRequest, filters: any) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlLocalPrograma}/listarHome`, {
      ...pageRequest,
      orderBy: "asc",
      ...filters,
      // filters: {
      //   codigoDistrito: null,
      //   codigoProvincia: null,
      //   codigoRegion: null,
      //   maxDistancia: 50,
      //   minDistancia: 1,
      //   tiposGestion: [],
      //   useFiltroDistancia: false,
      //   userGeoCoordinate: null
      // }
    });
  }

  // getCantidadCarrerasDWH = ():Observable<IServerResponse<{ cantidad: number }>> => {
  //   return this.http.get<any>(`${this.urlPortalTuniDWH}/CantidadProgramas`);
  // };
  // getCantidadCarrerasPorDepartamentoDWH = (ubigeo):Observable<IServerResponse<{ cantidad: number }>> => {
  //   return this.http.get<any>(`${this.urlPortalTuniDWH}/CantidadProgramasPorDepartamento/${ubigeo}`);
  // };

  getCantidadCarrerasDWH() {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/localPrograma/cantidad`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }

  getCantidadCarrerasPorDepartamentoDWH(ubigeo: string) {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/localPrograma/cantidadpordepartamento/${ubigeo}`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }


  getCantidadUniversidadesDWH = () => {
    console.log('getCantidadUniversidadesDWH==>', `${this.urlEntidad}/cantidad`);
    return this.http.post<IServerResponse<number>>(
      `${this.urlEntidad}/cantidad`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  };

  getCantidadUniversidadesPorDepartamentoDWH(ubigeo: string) {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/entidad/cantidadpordepartamento/${ubigeo}`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }

  getCantidadDocentesDWH = () => {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/docente/cantidad`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  };

  getCantidadDocentesPorDepartamentoDWH(ubigeo: string) {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/docente/cantidadpordepartamento/${ubigeo}`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }

  getCantidadEstudiantesDWH = () => {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/matricula/cantidad`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  };

  getCantidadEstudiantesPorDepartamentoDWH(ubigeo: string) {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/matricula/cantidadpordepartamento/${ubigeo}`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }

  getCantidadPostulantesPorDepartamentoDWH(ubigeo: string) {
    return this.http.post<IServerResponse<number>>(
      `${this.urlPortalTuniDWH}/postulante/cantidadpordepartamento/${ubigeo}`,
      {}
    ).pipe(map(r => CORE_FUNCTIONS.numberSpaces(r.data)));
  }

  getCantidadCarreras = (): Observable<IServerResponse<{ cantidad: number }>> => {
    return this.http.get<any>(`${this.urlPortalSiu}/ObtenerCantidadCarreras`);
  };

  searchUniversidades = (term, filters): Observable<IServerResponse<Array<IBusquedaAutoComplete>>> => {
    return this.http.post<any>(`${this.urlPortalSiu}/BusquedaAutocompletada/universidad/${term}`, { filters: filters });
  }

  searchCarreras = (term, filters): Observable<IServerResponse<Array<IBusquedaAutoComplete>>> => {
    return this.http.post<any>(`${this.urlPortalSiu}/BusquedaAutocompletada/carrera/${term}`, { filters: filters });
  }

  
  getObtenerEntidadesProgramaResumen = (): Observable<IResumenUniversidadPrograma> => {
     return this.http.post<IResumenUniversidadPrograma>(`${this.urlEntidad}/obtenerEntidadesProgramaResumen`,{});
  }
  
}
